module.exports = __webpack_public_path__ + "static/media/62-iveco-mercedes.803561cd.jpg";